export const metrics = {
  Balances: ['Active audits', 'Departments', 'All balances'] as const,
  Counts: ['Active audits2', 'Employees', 'All audits'] as const,
};

export type MetricsKey = typeof metrics['Balances'][number] | typeof metrics['Counts'][number];
